

































































import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import { modalScrollBottom } from '@/components/dialog/directives';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';

// 弹出框
@Component({
  components: { TooltipIcon },
  directives: { 'scroll-bottom': modalScrollBottom },
})
export default class Modal extends Vue {
  @Model('change') public modelValue!: boolean;

  // 弹窗标题
  @Prop({ type: String }) public title!: string;

  // 标题上的附加样式
  @Prop({ type: String }) public titleClass!: string;

  // 内容区域上的附加样式
  @Prop({ type: String }) public bodyClass!: string;

  // 弹窗宽度和高度
  @Prop({ type: [Number, String] }) public width!: number | string;
  @Prop({ type: [Number, String] }) public height!: number | string;

  // 是否显示遮罩层
  @Prop({ type: Boolean, default: false }) public mask!: boolean;

  // 按钮是否以文本形式显示
  @Prop({ type: Boolean, default: true }) public textBtn!: boolean;

  // 弹窗是否是加载中状态
  @Prop({ type: Boolean, default: false }) public loading!: boolean;

  // 是否显示关闭按钮
  @Prop({ type: Boolean, default: true }) public closable!: boolean;

  // 是否持久化，即点击弹窗以外的部分不关闭弹窗，需要手动关闭
  @Prop({ type: Boolean, default: true }) public persistent!: boolean;

  // 是否隐藏底部按钮
  @Prop({ type: Boolean, default: false }) public hideFooter!: boolean;
  
  // 是否滚动到底部
  @Prop({ type: Boolean, default: false }) public scrollBottom!: boolean;
  
  // 禁用关闭按钮
  @Prop({ type: Boolean, default: false }) public disableClose!: boolean;

  // 禁用提交按钮
  @Prop({ type: Boolean, default: false }) public disableSubmit!: boolean;

  // 禁用底部所有按钮
  @Prop({ type: Boolean, default: false }) public disableFooterBtn!: boolean;

  public visible = false;

  // 设置弹窗宽度，默认 950
  public get dialogWidth() {
    const w = parseInt(`${this.width}`, 10);
    return isNaN(w) ? 950 : w;
  }

  // 设置内容区域高度
  public get contentStyle() {
    const h = parseInt(`${this.height}`, 10);
    const height = isNaN(h) ? undefined : h;
    return height ? { height: `${height}px` } : null;
  }

  // 标题样式
  public get headerClass() {
    return { 'pr-2': this.closable, 'py-2': this.closable };
  }

  // 禁用取消按钮
  public get cancelDisabled() {
    return this.loading || this.disableFooterBtn;
  }

  // 禁用确定按钮
  public get submitDisabled() {
    return this.loading || this.disableFooterBtn || this.disableSubmit;
  }

  // 关闭或取消
  public onCancel() {
    this.visible = false;
    this.$emit('cancel');
  }

  @Emit('change')
  @Watch('visible')
  public onVisibleChange(value: boolean) {
    return value;
  }

  @Watch('modelValue', { immediate: true })
  public modelValueChange(value: boolean) {
    this.visible = value;
  }
}
